import { render, staticRenderFns } from "./addadRevenue.vue?vue&type=template&id=a8a1a4be&"
import script from "./addadRevenue.vue?vue&type=script&lang=js&"
export * from "./addadRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a1a4be')) {
      api.createRecord('a8a1a4be', component.options)
    } else {
      api.reload('a8a1a4be', component.options)
    }
    module.hot.accept("./addadRevenue.vue?vue&type=template&id=a8a1a4be&", function () {
      api.rerender('a8a1a4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/components/addadRevenue.vue"
export default component.exports